export enum DiscountKind {
    Percentage = 'Percentage',
    Quota = 'Quota'
}
